/* eslint-disable */

import crypto from 'crypto'
export function getSign (obj) {
  // console.log(obj)
  if (typeof obj.sign !== 'undefined') {
    delete obj.sign
  }
  // console.log(object)
  const temp = keySort(obj)
  // console.log(temp)
  const appkey = 'jkDD16r8wbfPU5I1'

  let protoSign = ''
  for (var d in temp) {
    // console.log(!isArray(temp[d]))
    if (temp[d] !== '' && temp[d] !== null && !isArray(temp[d])) {
      protoSign += d + '=' + encodeURIComponent(temp[d]) + '&'
    }
  }
  protoSign += 'app_key=' + appkey
  // console.log(protoSign)
  const md5 = crypto.createHash('md5')
  // console.log(protoSign)
  md5.update(protoSign)
  var sign = md5.digest('hex').toUpperCase()
  return sign
}
export function keySort (obj) {
  const newkey = Object.keys(obj).sort()
  // console.log(obj)
  const newObj = {}
  for (var i = 0; i < newkey.length; i++) {
    newObj[newkey[i]] = obj[newkey[i]]
  }
  return newObj
}
export function validateUser (rule, value, callback) {
  if (value === '') {
    callback(new Error('用户名不能为空'))
  } else {
    callback()
  }
}
export function validatePhone (rule, value, callback) {
  if (/^1[3456789]\d{9}$/.test(value) === false) {
    callback(new Error('请输入正确的手机号'))
  } else {
    callback()
  }
}
export function validatePass (rule, value, callback) {
  if (value === '') {
    callback(new Error('密码不能为空'))
  } else {
    callback()
  }
  // if (/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{6,20}$/.test(value) === false) {
  //   callback(new Error('请输入6-20位密码，必须包含大小写字母和数字'))
  // } else {
  //   callback()
  // }
}
export function validateCode (rule, value, callback) {
  if (value === '') {
    callback(new Error('验证码不能为空'))
  } else {
    callback()
  }
}
export function validateUsername (rule, value, callback) {
  if (/^[0-9a-zA-Z\u4e00-\u9fa5_]{2,20}$/.test(value) === false) {
    callback(
      new Error('姓名可包含2-20位汉字、数字、字母（大小写）、下划线!')
    )
  } else {
    callback()
  }
}
export function isArray (obj) {
  if (Object.prototype.toString.call(obj).toLocaleLowerCase() === '[object array]') {
    return true
  }
  return false
}
